export const PAGE_CONFIG = {
  "title": "Monthly",
  "titleCN": "运营总况月报",
  "subTitle": "",
  "subTitleCN": "",
  "path": "/overview/pcConsoleMonthly",
  "defaultTab": "overall",
  "tabList": [
    {
      "id": "overall",
      "tabName": "Overall",
      "tabNameCN": "总览",
      "isHaveNotification": true,
      "notificationPath": "/overview/pcConsoleMonthly",
      "path": "/overview/pcConsoleMonthly/overall",
      "tabIcon": "chart-map",
      "logConfig": {
        "pageId": "204601",
        "pageName": "mothlyOverall",
        "extInfo": "mothlyOverall",
        "pagePath": "/overview/pcConsoleMonthly/overall"
      },
      "filters": [
        {
          "name": "PcConsoleMonthlyFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/overview/pcConsoleMonthly/overall",
          "componentList": [
            {
              "name": "KeyMetricTitle",
              "className": "",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/overview_month/country_region_platform",
                  "metric": "units"
                }
              }
            },
            {
              "name": "PlatformMetricsCo",
              "className": "margin-t-20",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/overview_month/card_metrics",
                  "metricsList": [
                    "units_number",
                    "net_revenue"
                  ]
                }
              },
              "children": [
                {
                  "name": "CommonRow",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "PlatformCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "componentMetrics": [
                                {
                                  "metricKey": "units_number",
                                  "enName": "Full Game Units",
                                  "cnName": "本体拷贝销售数",
                                  "rangeEnName": "Full Game Units",
                                  "rangeCnName": "本体拷贝销售数",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc Metrics Full Game Units",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "game",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "PlatformCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "componentMetrics": [
                                {
                                  "metricKey": "net_revenue",
                                  "enName": "Net Revenue",
                                  "cnName": "净收入",
                                  "rangeEnName": "Net Revenue",
                                  "rangeCnName": "净收入",
                                  "preUnit": "$",
                                  "endUnit": "",
                                  "rainbowKey": "Pc Metrics Net Revenue",
                                  "type": "decimals",
                                  "decimal": 2,
                                  "icon": "dollar",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "KeyMetricsCo",
              "className": "dbd-daily-card",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/overview_month/card_metrics",
                  "isDark": true,
                  "mainMetricsList": [
                    "active_users",
                    "mtx_revenue",
                    "new_users",
                    "m1t1",
                    "mtx_arpu",
                    "mtx_payer_rate"
                  ],
                  "metricsList": [
                    "active_users",
                    "mtx_revenue",
                    "new_users",
                    "m1t1",
                    "mtx_arpu",
                    "mtx_payer_rate"
                  ]
                }
              },
              "children": [
                {
                  "name": "CommonRow",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "jumpUrl": "/engagement/active",
                              "componentMetrics": [
                                {
                                  "metricKey": "active_users",
                                  "enName": "MAU",
                                  "cnName": "月活跃",
                                  "rangeEnName": "Avg.MAU",
                                  "rangeCnName": "月平均活跃",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc MAU",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "user-u",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "jumpUrl": "/monetization/revenue",
                              "componentMetrics": [
                                {
                                  "metricKey": "mtx_revenue",
                                  "enName": "In-Game Revenue",
                                  "cnName": "内购收入",
                                  "rangeEnName": "In-Game Revenue",
                                  "rangeCnName": "内购收入",
                                  "preUnit": "$",
                                  "endUnit": "",
                                  "rainbowKey": "Pc In-Game Revenue",
                                  "type": "decimals",
                                  "decimal": 2,
                                  "icon": "dollar",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "jumpUrl": "/engagement/register",
                              "componentMetrics": [
                                {
                                  "metricKey": "new_users",
                                  "enName": "New",
                                  "cnName": "新进用户",
                                  "rangeEnName": "New",
                                  "rangeCnName": "新进用户",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc Metrics New",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "user-plus",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "CommonRow",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "jumpUrl": "/retention/index",
                              "componentMetrics": [
                                {
                                  "metricKey": "m1t1",
                                  "enName": "M1(T-1)",
                                  "cnName": "次月留存(T-1)",
                                  "rangeEnName": "M1(T-1)",
                                  "rangeCnName": "次月留存(T-1)",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc M1(T-1)",
                                  "type": "percent",
                                  "decimal": 2,
                                  "icon": "user-success",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "jumpUrl": "/monetization/revenue",
                              "componentMetrics": [
                                {
                                  "metricKey": "mtx_arpu",
                                  "enName": "In-Game ARPU",
                                  "cnName": "内购ARPU",
                                  "rangeEnName": "In-Game ARPU",
                                  "rangeCnName": "内购ARPU",
                                  "preUnit": "$",
                                  "endUnit": "",
                                  "rainbowKey": "Pc In-Game ARPU",
                                  "type": "decimals",
                                  "decimal": 2,
                                  "icon": "user-dollar",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "jumpUrl": "/monetization/revenue",
                              "componentMetrics": [
                                {
                                  "metricKey": "mtx_payer_rate",
                                  "enName": "In-Game Payer%",
                                  "cnName": "内购付费渗透率",
                                  "rangeEnName": "In-Game Payer%",
                                  "rangeCnName": "内购付费渗透率",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc In-Game Payer%",
                                  "type": "percent",
                                  "decimal": 2,
                                  "icon": "pie-chart-icon",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "EventService",
              "className": "",
              "type": "view",
              "style": {
                "marginTop": "10px"
              },
              "props": {},
              "children": [
                {
                  "name": "CommonRow",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "OverviewMetricsTrendCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "renderIndex": 0,
                              "api": {
                                "metricsApi": "/api/v1/dashboard/pc/overview_month/metrics_trend",
                                "dimensionApi": "/api/v1/dashboard/pc/overview_month/dimension/metrics_trend"
                              },
                              "componentMetrics": [
                                {
                                  "enName": "MAU",
                                  "cnName": "月活跃",
                                  "metricKey": "active_users",
                                  "type": "int",
                                  "decimal": 0
                                },
                                {
                                  "enName": "New",
                                  "cnName": "新进用户",
                                  "metricKey": "new_users",
                                  "type": "int",
                                  "decimal": 0
                                },
                                {
                                  "enName": "M1",
                                  "cnName": "次月留存",
                                  "metricKey": "m1",
                                  "type": "percent",
                                  "decimal": 2
                                },
                                {
                                  "enName": "M2",
                                  "cnName": "2月留存",
                                  "metricKey": "m2",
                                  "type": "percent",
                                  "decimal": 2
                                },
                                {
                                  "enName": "M3",
                                  "cnName": "3月留存",
                                  "metricKey": "m3",
                                  "type": "percent",
                                  "decimal": 2
                                },
                                {
                                  "enName": "TNU",
                                  "cnName": "总注册用户数",
                                  "metricKey": "total_users",
                                  "type": "int",
                                  "decimal": 0
                                },
                                {
                                  "enName": "PCU",
                                  "cnName": "最高同时在线",
                                  "metricKey": "pcu",
                                  "type": "int",
                                  "decimal": 0
                                },
                                {
                                  "enName": "Avg.Playtime(min)",
                                  "cnName": "平均在线时长",
                                  "metricKey": "aot",
                                  "type": "decimals",
                                  "decimal": 2
                                },
                                {
                                  "enName": "Sessions per user",
                                  "cnName": "平均登录次数",
                                  "metricKey": "alc",
                                  "type": "decimals",
                                  "decimal": 2
                                }
                              ]
                            }
                          }
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "OverviewMetricsTrendCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "renderIndex": 1,
                              "api": {
                                "metricsApi": "/api/v1/dashboard/pc/overview_month/metrics_trend",
                                "dimensionApi": "/api/v1/dashboard/pc/overview_month/dimension/metrics_trend"
                              },
                              "componentMetrics": [
                                {
                                  "enName": "Net Rev($)",
                                  "cnName": "净收入($)",
                                  "metricKey": "net_revenue",
                                  "type": "decimals",
                                  "decimal": 2
                                },
                                {
                                  "enName": "In-Game Rev($)",
                                  "cnName": "内购收入($)",
                                  "metricKey": "mtx_revenue",
                                  "type": "decimals",
                                  "decimal": 2
                                },
                                {
                                  "enName": "Full Game Units",
                                  "cnName": "本体拷贝销售数",
                                  "metricKey": "units_number",
                                  "type": "int",
                                  "decimal": 0
                                },
                                {
                                  "enName": "Full Game Rev($)",
                                  "cnName": "本体拷贝收入($)",
                                  "metricKey": "units_revenue",
                                  "type": "decimals",
                                  "decimal": 2
                                },
                                {
                                  "enName": "In-Game ARPPU",
                                  "cnName": "内购付费ARPPU",
                                  "metricKey": "mtx_arppu",
                                  "type": "decimals",
                                  "decimal": 2
                                },
                                {
                                  "enName": "In-Game ARPU",
                                  "cnName": "内购ARPU",
                                  "metricKey": "mtx_arpu",
                                  "type": "decimals",
                                  "decimal": 2
                                },
                                {
                                  "enName": "In-Game Payer",
                                  "cnName": "内购付费人数",
                                  "metricKey": "mtx_payers",
                                  "type": "int",
                                  "decimal": 0
                                },
                                {
                                  "enName": "In-Game Payer%",
                                  "cnName": "内购付费渗透率",
                                  "metricKey": "mtx_payer_rate",
                                  "type": "percent",
                                  "decimal": 2
                                },
                              ]
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "OverviewTableCo",
              "className": "",
              "type": "view",
              "style": {
                "marginTop": "20px"
              },
              "props": {
                "config": {
                  "api": {
                    "tableApi": "/api/v1/dashboard/pc/overview_month/overall_performance",
                    "tableDownloadApi": "/api/v1/dashboard/pc/overview_month/overall_performance/download"
                  },
                  "componentMetrics": [
                    {
                      "metricKey": "total_users",
                      "reqMetricKey": "total_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 110,
                      "cnWidth": 130,
                      "enName": "TNU",
                      "cnName": "总注册用户数",
                      "rainbowKey": "Pc TNU",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "new_users",
                      "reqMetricKey": "new_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 110,
                      "cnWidth": 110,
                      "enName": "New",
                      "cnName": "新进用户",
                      "rainbowKey": "Pc New",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "avg_new_users",
                      "reqMetricKey": "avg_new_users",
                      "enPercentWidth": 140,
                      "cnPercentWidth": 170,
                      "enWidth": 140,
                      "cnWidth": 170,
                      "enName": "Avg.Daily New",
                      "cnName": "平均每日新进用户数",
                      "rainbowKey": "Avg.Daily New",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "active_users",
                      "reqMetricKey": "active_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 110,
                      "cnWidth": 110,
                      "enName": "MAU",
                      "cnName": "月活跃",
                      "rainbowKey": "Pc MAU",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "avg_active_users",
                      "reqMetricKey": "avg_active_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 155,
                      "cnWidth": 130,
                      "enName": "Month Avg.DAU",
                      "cnName": "月平均日活跃",
                      "rainbowKey": "Month Avg.DAU",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "net_revenue",
                      "reqMetricKey": "net_revenue",
                      "enPercentWidth": 190,
                      "cnPercentWidth": 190,
                      "enWidth": 140,
                      "cnWidth": 130,
                      "enName": "Net Revenue($)",
                      "cnName": "净收入($)",
                      "rainbowKey": "Pc Metrics Net Revenue",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "avg_net_revenue",
                      "reqMetricKey": "avg_net_revenue",
                      "enPercentWidth": 260,
                      "cnPercentWidth": 190,
                      "enWidth": 260,
                      "cnWidth": 140,
                      "enName": "Month Avg.Net Revenue($)",
                      "cnName": "月平均净收入($)",
                      "rainbowKey": "Pc Month Avg.Net Revenue($)",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "units_number",
                      "reqMetricKey": "units_number",
                      "enPercentWidth": 180,
                      "cnPercentWidth": 180,
                      "enWidth": 155,
                      "cnWidth": 155,
                      "enName": "Full Game Units",
                      "cnName": "本体拷贝销售数",
                      "rainbowKey": "Pc Units",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "avg_units_number",
                      "reqMetricKey": "avg_units_number",
                      "enPercentWidth": 230,
                      "cnPercentWidth": 190,
                      "enWidth": 230,
                      "cnWidth": 190,
                      "enName": "Month Avg.Full Game Units",
                      "cnName": "月平均本体拷贝销量数",
                      "rainbowKey": "Pc Month Avg.Full Game Units",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "units_revenue",
                      "reqMetricKey": "units_revenue",
                      "enPercentWidth": 200,
                      "cnPercentWidth": 210,
                      "enWidth": 210,
                      "cnWidth": 140,
                      "enName": "Full Game Revenue($)",
                      "cnName": "本体拷贝收入($)",
                      "rainbowKey": "Pc Units Revenue",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "avg_units_revenue",
                      "reqMetricKey": "avg_units_revenue",
                      "enPercentWidth": 280,
                      "cnPercentWidth": 190,
                      "enWidth": 280,
                      "cnWidth": 180,
                      "enName": "Month Avg.Full Game Revenue($)",
                      "cnName": "月平均本体拷贝收入($)",
                      "rainbowKey": "Pc Month Avg.Full Game Revenue($)",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "mtx_revenue",
                      "reqMetricKey": "mtx_revenue",
                      "enPercentWidth": 190,
                      "cnPercentWidth": 190,
                      "enWidth": 200,
                      "cnWidth": 170,
                      "enName": "In-Game Revenue($)",
                      "cnName": "内购收入($)",
                      "rainbowKey": "Pc In-Game Revenue($)",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "mtx_payers",
                      "reqMetricKey": "mtx_payers",
                      "enPercentWidth": 170,
                      "cnPercentWidth": 170,
                      "enWidth": 150,
                      "cnWidth": 130,
                      "enName": "In-Game Payer",
                      "cnName": "内购付费人数",
                      "rainbowKey": "Pc In-Game Payer",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "mtx_payer_rate",
                      "reqMetricKey": "mtx_payer_rate",
                      "enPercentWidth": 130,
                      "cnPercentWidth": 130,
                      "enWidth": 165,
                      "cnWidth": 130,
                      "enName": "In-Game Payer%",
                      "cnName": "内购付费渗透率",
                      "rainbowKey": "Pc In-Game Payer%",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "mtx_arpu",
                      "reqMetricKey": "mtx_arpu",
                      "enPercentWidth": 130,
                      "cnPercentWidth": 130,
                      "enWidth": 145,
                      "cnWidth": 130,
                      "enName": "In-Game ARPU",
                      "cnName": "内购ARPU",
                      "rainbowKey": "Pc In-Game ARPU",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "mtx_arppu",
                      "reqMetricKey": "mtx_arppu",
                      "enPercentWidth": 190,
                      "cnPercentWidth": 190,
                      "enWidth": 150,
                      "cnWidth": 150,
                      "enName": "In-Game ARPPU",
                      "cnName": "内购付费ARPPU",
                      "rainbowKey": "Pc In-Game ARPPU",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "avg_time_to_purchase",
                      "reqMetricKey": "avg_time_to_purchase",
                      "enPercentWidth": 210,
                      "cnPercentWidth": 190,
                      "enWidth": 210,
                      "cnWidth": 190,
                      "enName": "Time to Purchase (days)",
                      "cnName": "购买时间间隔(天)",
                      "rainbowKey": "Time to Purchase (days)",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "m1",
                      "reqMetricKey": "m1",
                      "enPercentWidth": 155,
                      "cnPercentWidth": 155,
                      "enWidth": 85,
                      "cnWidth": 80,
                      "enName": "M1",
                      "cnName": "次月留存",
                      "rainbowKey": "Pc M1",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "m2",
                      "reqMetricKey": "m2",
                      "enPercentWidth": 155,
                      "cnPercentWidth": 155,
                      "enWidth": 85,
                      "cnWidth": 80,
                      "enName": "M2",
                      "cnName": "2月留存",
                      "rainbowKey": "M2",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "m3",
                      "reqMetricKey": "m3",
                      "enPercentWidth": 155,
                      "cnPercentWidth": 155,
                      "enWidth": 85,
                      "cnWidth": 80,
                      "enName": "M3",
                      "cnName": "3月留存",
                      "rainbowKey": "M3",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "pcu",
                      "reqMetricKey": "pcu",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 85,
                      "cnWidth": 122,
                      "enName": "PCU",
                      "cnName": "最高同时在线",
                      "rainbowKey": "PCU",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "acu",
                      "reqMetricKey": "acu",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 85,
                      "cnWidth": 122,
                      "enName": "ACU",
                      "cnName": "平均同时在线",
                      "rainbowKey": "ACU",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "aot",
                      "reqMetricKey": "aot",
                      "enPercentWidth": 170,
                      "cnPercentWidth": 160,
                      "enWidth": 170,
                      "cnWidth": 160,
                      "enName": "Avg.Playtime(min)",
                      "cnName": "平均在线时长(分钟)",
                      "rainbowKey": "Pc Metrics Avg.Playtime",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "alc",
                      "reqMetricKey": "alc",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 125,
                      "enWidth": 160,
                      "cnWidth": 125,
                      "enName": "Sessions per user",
                      "cnName": "平均登录次数",
                      "rainbowKey": "Pc Metrics Session",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "retention_users",
                      "reqMetricKey": "retention_users",
                      "enPercentWidth": 196,
                      "cnPercentWidth": 130,
                      "enWidth": 196,
                      "cnWidth": 130,
                      "enName": "MAU Retention Users",
                      "cnName": "月活留存",
                      "rainbowKey": "MAU Retention Users",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "churn_users",
                      "reqMetricKey": "churn_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 130,
                      "cnWidth": 100,
                      "enName": "Churn Users",
                      "cnName": "月流失",
                      "rainbowKey": "Churn Users",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "churn_rate",
                      "reqMetricKey": "churn_rate",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 80,
                      "cnWidth": 86,
                      "enName": "Churn%",
                      "cnName": "流失率",
                      "rainbowKey": "Churn%",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "return_users",
                      "reqMetricKey": "return_users",
                      "enPercentWidth": 180,
                      "cnPercentWidth": 170,
                      "enWidth": 170,
                      "cnWidth": 95,
                      "enName": "MAU Return Users",
                      "cnName": "月回流",
                      "rainbowKey": "MAU Return Users",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "weighted_m2",
                      "reqMetricKey": "weighted_m2",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 130,
                      "cnWidth": 130,
                      "enName": "Weighted M1",
                      "cnName": "加权次月留存",
                      "rainbowKey": "Weighted M1",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "weighted_m3",
                      "reqMetricKey": "weighted_m3",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 130,
                      "cnWidth": 130,
                      "enName": "Weighted M2",
                      "cnName": "加权2月留存",
                      "rainbowKey": "Weighted M2",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "weighted_m4",
                      "reqMetricKey": "weighted_m4",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 130,
                      "cnWidth": 130,
                      "enName": "Weighted M3",
                      "cnName": "加权3月留存",
                      "rainbowKey": "Weighted M3",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "id": "breakdown",
      "tabName": "Monthly Breakdown",
      "tabNameCN": "每月细分",
      "isHaveNotification": true,
      "notificationPath": "/overview/pcConsoleMonthly",
      "path": "/overview/pcConsoleMonthly/breakdown",
      "tabIcon": "pie-chart-icon",
      "logConfig": {
        "pageId": "204602",
        "pageName": "mothlyBreakdown",
        "extInfo": "mothlyBreakdown",
        "pagePath": "/overview/pcConsoleMonthly/breakdown"
      },
      "filters": [
        {
          "name": "PcConsoleMonthlyFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/overview/pcConsoleMonthly/breakdown",
          "componentList": [
            {
              "name": "CommonRow",
              "className": "",
              "type": "layout",
              "style": {
                "marginTop": "10px"
              },
              "props": {},
              "children": [
                {
                  "name": "UserCompositionCo",
                  "className": "",
                  "type": "view",
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/pc/overview_month/metrics_users"
                    }
                  },
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "MetricsUserCompositionCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "timeType": "MONTH",
                              "metricType": "mau"
                            }
                          }
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "MetricsUserCompositionCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "timeType": "MONTH",
                              "metricType": "system"
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "CommonRow",
              "className": "",
              "type": "layout",
              "style": {},
              "props": {},
              "children": [
                {
                  "name": "RankListTabCo",
                  "className": "",
                  "style": {},
                  "type": "view",
                  "data": {
                    "regionDataType": "os"
                  },
                  "children": [
                    {
                      "name": "MetricsRankListCo",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/pc/overview_month/country_region_platform",
                          "metric": "mau",
                          "haveCalBubble": false,
                          "isUserQuota": true,
                          "showConfig": {
                            "showTable": true,
                            "showChart": true
                          }
                        }
                      }
                    },
                    {
                      "name": "MetricsRankListCo",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/pc/overview_month/country_region_platform",
                          "metric": "mtx_revenue",
                          "haveCalBubble": false,
                          "isUserQuota": false,
                          "showConfig": {
                            "showTable": true,
                            "showChart": true
                          }
                        }
                      }
                    },
                    {
                      "name": "MetricsRankListCo",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/pc/overview_month/country_region_platform",
                          "metric": "new",
                          "haveCalBubble": false,
                          "isUserQuota": true,
                          "showConfig": {
                            "showTable": true,
                            "showChart": true
                          }
                        }
                      }
                    },
                    {
                      "name": "MetricsRankListCo",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/pc/overview_month/country_region_platform",
                          "metric": "units",
                          "haveCalBubble": true,
                          "isUserQuota": true,
                          "showConfig": {
                            "showTable": true,
                            "showChart": true
                          }
                        }
                      }
                    },
                    {
                      "name": "MetricsRankListCo",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/pc/overview_month/country_region_platform",
                          "metric": "revenue",
                          "haveCalBubble": true,
                          "isUserQuota": false,
                          "showConfig": {
                            "showTable": true,
                            "showChart": true
                          }
                        }
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};